(function () {
  if (window.__cardHoverVideoInit) return;
  window.__cardHoverVideoInit = true;

  const play = (v) => {
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
  };

  const bindHoverVideo = (root) => {
    root.querySelectorAll('video[data-card-hover-video]').forEach((video) => {
      const card = video.closest('.product-card-wrapper');
      if (!card || card.dataset.cardHoverVideoBound) return;
      card.dataset.cardHoverVideoBound = '1';

      // Bound to the card, not the video: the quick buy replaces the video when a colour
      // changes, so the current one is looked up at event time. Binding per video would
      // leave the discarded elements playing (and downloading) on every later hover.
      const current = () => card.querySelector('video[data-card-hover-video]');

      const start = () => {
        const v = current();
        if (!v) return;
        v.muted = true;
        v.setAttribute('playsinline', '');
        play(v);
      };

      const stop = () => {
        const v = current();
        if (!v) return;
        v.pause();
        v.currentTime = 0;
      };

      card.addEventListener('mouseenter', start);
      card.addEventListener('mouseleave', stop);
      card.addEventListener('focusin', start);
      card.addEventListener('focusout', stop);
    });
  };

  bindHoverVideo(document);

  const mo = new MutationObserver((muts) => {
    muts.forEach((m) =>
      m.addedNodes.forEach((n) => {
        if (n.nodeType === 1) bindHoverVideo(n);
      }),
    );
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();

(function () {
  if (window.__wideCardSizerInit) return;
  window.__wideCardSizerInit = true;

  const mql = window.matchMedia('(min-width: 1024px)');

  function size(grid) {
    const isDesktop = mql.matches;
    const wideAttr = isDesktop ? 'data-wide-desktop' : 'data-wide-mobile';
    const oppositeAttr = isDesktop ? 'data-wide-mobile' : 'data-wide-desktop';

    const refLi = grid.querySelector(`li:not([${wideAttr}="true"]):not([${oppositeAttr}="true"])`);
    const ref = refLi && refLi.querySelector('.card__inner.ratio');
    if (!ref) return;
    const refHeight = ref.getBoundingClientRect().height;
    if (!refHeight) return;

    grid.querySelectorAll(`li[${wideAttr}="true"] .card__inner.ratio`).forEach((inner) => {
      inner.style.setProperty('height', `${refHeight}px`, 'important');
    });
    grid.querySelectorAll(`li[${oppositeAttr}="true"]:not([${wideAttr}="true"]) .card__inner.ratio`).forEach((inner) => {
      inner.style.removeProperty('height');
    });
  }

  function init(grid) {
    if (grid.__wideCardSized) return;
    grid.__wideCardSized = true;
    const run = () => size(grid);
    run();
    const ro = new ResizeObserver(run);
    ro.observe(grid);
    grid.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', run, { once: true });
    });
    mql.addEventListener('change', run);
  }

  document.querySelectorAll('#product-grid').forEach(init);
  const mo = new MutationObserver(() => {
    document.querySelectorAll('#product-grid').forEach(init);
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
